module.exports = __webpack_public_path__ + "static/media/51-Down-Town-Final-Cam-01-Sunny ps.bf29487c.webp";